import React, { useEffect, useState } from "react";
import { NavLink as Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import ChangePassword from "../pages/Authentication/ChangePassword";
import DateFilter from "../pages/ConsultantDashboard/DateFilter";
import SearchBox from "../pages/ConsultantDashboard/SearchBox";
import axios from "../services/axios";
import DownloadCsv from "../pages/ConsultantDashboard/DownloadCsv";

function ConsultantNavbar({
  path,
  setSearchText,
  setDefaultDate,
  setCurrent,
  consultantDataCount,
  fetchData,
  csvData,
}) {
  const history = useHistory();
  function onClickLogout() {
    localStorage.removeItem("consultant.name");
    localStorage.removeItem("consultant.token");
    localStorage.removeItem("consultant.email");
    localStorage.removeItem("consultant.role");
    history.push("/consultant");
  }

  // const [defaultDate, setDefaultDate] = useState([]);
  // const [current, setCurrent] = useState(1);
  // const [searchText, setSearchText] = useState("");
  const [dataCount, setDataCount] = useState({});
  const [load, setLoad] = useState(false);
  const [candidates, setCandidates] = useState([]);

  // function fetchData(searchText) {
  //   setLoad(true);
  //   axios
  //     .get(
  //       `/consultant?page=${current}&limit=10&consultantName=${consultantName}&search=${searchText}&startDate=${
  //         defaultDate[0] ? defaultDate[0] : ""
  //       }&endDate=${defaultDate[1] ? defaultDate[1] : ""}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("user.token")}`,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       const data = res.data;
  //       setCandidates(data);
  //       setLoad(false);
  //     })
  //     .catch((err) => {
  //       setLoad(false);
  //     });
  // }
  const consultantName = localStorage.getItem("consultant.name");

  // function consultantDataCount(searchText) {
  //   setLoad(true);
  //   axios
  //     .get(
  //       `/consultant/Count?consultancyName=${consultantName}&search=${searchText}&startDate=${
  //         defaultDate[0] ? defaultDate[0] : ""
  //       }&endDate=${defaultDate[1] ? defaultDate[1] : ""}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${localStorage.getItem("user.token")}`,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       setDataCount(res.data);
  //       setLoad(false);
  //     })
  //     .catch((err) => {
  //       setLoad(false);
  //     });
  // }

  // useEffect(() => {
  //   fetchData(searchText);
  //   consultantDataCount(searchText);
  // }, [consultantName, current, defaultDate]);

  return (
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 mt-0 static-top shadow client-navbar">
      <ul className="navbar-nav">
        {/* <li className="nav-item">
          <Link className="nav-link" to="/consultantdashboard" exact>
            <h6 className="mb-0">Dashboard</h6>
          </Link>
        </li> */}
        <li className="d-flex align-items-center">
          <SearchBox
            setSearchText={setSearchText}
            fetchData={fetchData}
            consultantDataCount={consultantDataCount}
            setCurrent={setCurrent}
          />
        </li>
        <li className="d-flex align-items-center ml-2">
          <DateFilter setDefaultDate={setDefaultDate} setCurrent={setCurrent} />
        </li>
        <li className="d-flex align-items-center ml-2">
          <DownloadCsv csvData={csvData} />
        </li>

        {/* <li className="nav-item">
          <Link className="nav-link" to="/selectedcandidates" exact>
            <h6 className="mb-0">Selected Candidates</h6>
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/joinedcandidates" exact>
            <h6 className="mb-0">Joined Candidates</h6>
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/pendingcandidates" exact>
            <h6 className="mb-0">Pending Candidates</h6>
          </Link>
        </li>
        <li className="nav-item">
          <Link className="nav-link" to="/rejectedcandidates" exact>
            <h6 className="mb-0">Rejected Candidates</h6>
          </Link>
        </li> */}
      </ul>
      <ul className="navbar-nav ml-auto">
        <li className="nav-item dropdown no-arrow">
          <a
            className="nav-link dropdown-toggle"
            href="#/"
            id="userDropdown"
            role="button"
            data-toggle="dropdown"
          >
            <span className="mr-3 d-none d-lg-inline text-gray-600 small">
              <i class="fas fa-user-circle mr-2" aria-hidden="true"></i>
              {consultantName}
            </span>
          </a>

          <div className="dropdown-menu dropdown-menu-right shadow animated--grow-in">
            <a className="dropdown-item" href="#/">
              <i className="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
              Profile
            </a>
            <ChangePassword component={"consultant"} />
            <div className="dropdown-divider"></div>
            <button className="dropdown-item" onClick={onClickLogout}>
              <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
              Logout
            </button>
          </div>
        </li>
      </ul>
    </nav>
  );
}

export default ConsultantNavbar;
